<script lang="ts"></script>

<div class="flex flex-col gap-[.125rem]">
	<div class="h-px w-3 bg-black"></div>
	<div class="h-px w-3 bg-black"></div>
	<div class="h-px w-3 bg-black"></div>
</div>
